<woa-modal-page-layout [title]="title()" [translationParams]="{'groupOrderName': currentGroupOrderName() | possessive}">
    @if (errorKey()) {
        <woa-content-message [level]="MessageLevel.ERROR" class="group-order-error"
                             [text]="errorKey()" [translationParams]="errorParams()"></woa-content-message>
    } @else {
        @if (mode() === GroupOrderPageMode.EDIT) {
            <div class="group-order-intro"
                 [ngClass]="{'no-details': !groupOrderModel.canStartGroupOrder()}">
                @if (showEditIntroHeading()) {
                    <div class="group-order-intro-heading"
                         [innerHTML]="'woa.message.group-order.intro.create.heading' | translate | html"></div>
                }
                <div class="group-order-intro-body" [innerHTML]="editIntroBody() | translate | html"></div>
            </div>
        }
        @if (mode() === GroupOrderPageMode.PARTICIPANTS) {
            <div class="participation-intro">
                <div class="participation-intro-heading"
                     [innerHTML]="participantIntroHeading() | translate: {
                                        'otherGroupOrderName': newestOtherTransferTarget()?.name | possessive,
                                        'existingGroupOrderName': existingTransferTarget()?.name | possessive
                 } | html"></div>
                <div class="participation-intro-body"
                     [innerHTML]="participantIntroBody() | translate: {
                                        'otherGroupOrderName': newestOtherTransferTarget()?.name | possessive,
                                        'otherGroupOrderOwnerName': newestOtherTransferTarget()?.name,
                                        'existingGroupOrderName': existingTransferTarget()?.name | possessive
                 } | html"></div>
            </div>
        }
    }
    @if (mode() === GroupOrderPageMode.EDIT && groupOrderModel.canStartGroupOrder()) {
        <div class="group-order-details">
            <woa-form (onSubmit)="saveGroupOrder()">
                <woa-text-field class="group-order-details-name" [(ngModel)]="newGroupOrderName" name="name"
                                [label]="'woa.label.group-order.groupOrderName'" required [maxlength]="'25'"
                                [autocomplete]="'given-name'"></woa-text-field>
            </woa-form>
            @if (showEditInstructions()) {
                <div class="group-order-details-instructions" woa-activatable
                     (onActivate)="toggleEditInstructions(instructions)">
                    <div class="group-order-details-instructions-heading" woa-touchable>
                        <div class="group-order-details-instructions-heading-label"
                             [innerHTML]="'woa.message.group-order.instructions.heading' | translate | html"></div>
                        <woa-toggle class="group-order-details-instructions-heading-toggle"
                                    [active]="instructionsExpanded"></woa-toggle>
                    </div>
                    <ol class="group-order-details-instructions-body" [ngClass]="{'expanded': instructionsExpanded}"
                        #instructions>
                        <li class="group-order-details-instructions-body-item"
                            [innerHTML]="'woa.message.group-order.instructions.body.point1' | translate | html">
                        </li>
                        <li class="group-order-details-instructions-body-item"
                            [innerHTML]="'woa.message.group-order.instructions.body.point2' | translate | html">
                        </li>
                        <li class="group-order-details-instructions-body-item"
                            [innerHTML]="'woa.message.group-order.instructions.body.point3' | translate | html">
                        </li>
                    </ol>
                </div>
            }
            @if (showEditParticipants()) {
                <div class="group-order-details-participants">
                    <div class="group-order-details-participants-heading">
                        {{ editParticipantsHeading() | translate }}
                    </div>
                    @if (!orderModel.totalTransfers()) {
                        <div class="group-order-details-participants-message"
                             [innerHTML]="'woa.message.group-order.noParticipants' | translate | html"></div>
                    }
                    @if (orderModel.totalTransfers()) {
                        <div class="group-order-details-participants-requests">
                            @for (request of orderModel.transferRequests(); track request) {
                                @if (request.transferRequestId) {
                                    <div class="group-order-details-participants-requests-request"
                                         [ngClass]="{'removed': removedRequestIds.has(request.transferRequestId)}">
                                        <div class="group-order-details-participants-requests-request-name">
                                            {{ request.transferRequestName }}
                                        </div>
                                        @if (request.subTotal) {
                                            <div class="group-order-details-participants-requests-request-subtotal">
                                                {{ request.subTotal | woaCurrency }}
                                            </div>
                                        }
                                        <woa-icon-button class="group-order-details-participants-requests-request-remove"
                                                         [type]="removedRequestIds.has(request.transferRequestId) ? IconButtonType.INCREMENT : IconButtonType.REMOVE"
                                                         (onActivate)="toggleRequest(request)"></woa-icon-button>
                                    </div>
                                }
                            }
                        </div>
                    }
                </div>
            }
        </div>
    }
    @if (mode() === GroupOrderPageMode.PARTICIPANTS) {
        <div class="participation-details">
            <woa-form (onSubmit)="joinGroupOrder($event)">
                <woa-text-field class="participation-details-name" [(ngModel)]="orderFirstName" name="name"
                                [label]="'woa.label.common.firstName'" required [maxlength]="'25'"
                                [autocomplete]="'given-name'"></woa-text-field>
            </woa-form>
            @if (otherTransferTargets().length > 1) {
                <div class="participation-details-targets">
                    <div class="participation-details-targets-heading" woa-touchable woa-activatable
                         (onActivate)="toggleParticipantTargets(targetList)">
                        <div class="participation-details-targets-heading-label">
                            {{ 'woa.heading.group-order.targets' | translate }}
                        </div>
                        <woa-toggle class="participation-details-targets-heading-toggle"
                                    [active]="targetsExpanded"></woa-toggle>
                    </div>
                    <div class="participation-details-targets-list" [ngClass]="{'expanded': targetsExpanded}"
                         #targetList>
                        @for (target of otherTransferTargets(); track target) {
                            <div class="participation-details-targets-list-target" woa-activatable
                                 (onActivate)="selectParticipantTarget(target)">
                                <woa-selector-control class="participation-details-targets-list-target-selector"
                                                      [type]="SelectorType.RADIO"
                                                      [selected]="target === selectedTransferTarget()"
                                                      (selectedChange)="selectParticipantTarget(target)"></woa-selector-control>
                                <div class="participation-details-targets-list-target-name">
                                    {{ target.name }}
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    }
    @if ((mode() === GroupOrderPageMode.EDIT && groupOrderModel.groupOrderStatus() !== OrderTransferTargetStatus.CLOSED && groupOrderModel.canStartGroupOrder()) || this.reorderStatus()) {
        <woa-button woa-page-footer-control id="cancel-group-order-button"
                    [prominence]="ButtonProminence.LOW" [connotation]="ButtonConnotation.NEGATIVE"
                    [label]="cancelButtonLabel()"
                    (onActivate)="closeGroupOrder()"></woa-button>
    }
    @if (form() && mode() === GroupOrderPageMode.EDIT) {
        <woa-button woa-page-footer-control id="save-group-order-button" [label]="saveButtonLabel()"
                    (onActivate)="form().submit()"></woa-button>
    }
    @if (mode() === GroupOrderPageMode.PARTICIPANTS && !existingTransferTarget()) {
        <woa-button woa-page-footer-control id="no-join-group-order-button"
                    [prominence]="ButtonProminence.LOW" [label]="'woa.button.group-order.noJoin'"
                    (onActivate)="dismiss()"></woa-button>
    }
    @if (form() && mode() === GroupOrderPageMode.PARTICIPANTS && existingTransferTarget() && newestOtherTransferTarget()) {
        <woa-button woa-page-footer-control id="keep-group-order-button"
                    [prominence]="ButtonProminence.LOW"
                    [label]="'woa.button.group-order.keep'"
                    [translationParams]="{'groupOrderName': existingTransferTarget()?.name | possessive}"
                    (onActivate)="form().submit(existingTransferTarget())"></woa-button>
    }
    @if (form() && mode() === GroupOrderPageMode.PARTICIPANTS) {
        <woa-button id="join-group-order-button"
                    woa-page-footer-control
                    [label]="joinButtonLabel()"
                    [translationParams]="{'groupOrderName': selectedTransferTarget()?.name | possessive}"
                    (onActivate)="form().submit(selectedTransferTarget())"></woa-button>
    }
    @if (mode() === GroupOrderPageMode.PARTICIPANTS && !hideNewGroupOrder()) {
        <woa-link class="participation-link" slot="footer-end" [link]="'woa.button.group-order.createNew'"
                  (onActivate)="startNewGroupOrder()"></woa-link>
    }
</woa-modal-page-layout>
